import reducer from './reducer'

import * as loanRateSettingsOperations from './operations'
import * as loanRateSettingsSelectors from './selectors'

export { loanRateSettingsOperations, loanRateSettingsSelectors }

export default reducer
